<template>
    <div class="user">
        <!--搜索表单-->
        <div class="common-seach-wrap">
            <el-button size="small" type="primary" icon="el-icon-plus" @click="$refs.edit.showDialog()">添加活动</el-button>
        </div>
        <div class="table-wrap">
            <el-table v-loading="loading" :data="tableData" style="width: 100%">
                <el-table-column prop="activity_id" label="平台活动ID" width="100"></el-table-column>
                <el-table-column prop="title" label="平台活动标题">
                    <template slot-scope="scope">
                        <div class="text-ellipsis" :title="scope.row.title">{{ scope.row.title }}</div>
                    </template>
                </el-table-column>
                <el-table-column prop="image" label="广告图" width="80">
                    <template slot-scope="scope">
                        <img v-img-url="scope.row.image.file_path" width="50px;" height="50px" alt="" />
                    </template>
                </el-table-column>
                <el-table-column prop="sort" label="排序" width="100"></el-table-column>
                <el-table-column prop="start_time" label="活动开始时间" width="150"></el-table-column>
                <el-table-column prop="end_time" label="活动结束时间" width="150"></el-table-column>
                <el-table-column prop="join_end_time" label="报名截止日期" width="150"></el-table-column>
                <el-table-column prop="status" label="状态" width="100">
                    <template slot-scope="scope">
                        <span v-if="scope.row.status == 1" class="green">生效</span>
                        <span v-if="scope.row.status == 0" class="gray">未生效</span>
                    </template>
                </el-table-column>
                <el-table-column prop="create_time" label="添加时间" width="140"></el-table-column>
                <el-table-column prop="update_time" label="更新时间" width="140"></el-table-column>
                <el-table-column prop="name" label="操作" width="80">
                    <template slot-scope="scope">
                        <div class="table-btn-column">
                            <el-button type="text" size="small" @click="$refs.edit.showDialog(scope.row)">编辑</el-button>
                            <el-button type="text" class="yellow" size="small" @click="goodsItem(scope.row)">绑定商品</el-button>
                            <el-button type="text" size="small" @click="honorItem(scope.row)">活动荣誉</el-button>
                            <el-button type="text" size="small" @click="questionItem(scope.row)">常见问题</el-button>
                            <el-button type="text" size="small" @click="$refs.intro.showDialog(scope.row.activity_id)">活动介绍</el-button>
                            <el-button type="text" size="small" @click="$refs.rule.showDialog(scope.row.activity_id)">活动规则</el-button>
                            <el-button type="text" size="small" @click="deleteClick(scope.row)">删除</el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>

            <!--分页-->
            <div class="pagination">
                <el-pagination
                    background
                    :current-page="curPage"
                    :page-size="pageSize"
                    layout="total, prev, pager, next, jumper"
                    :total="totalDataNumber"
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                ></el-pagination>
            </div>
        </div>
        <!--活动介绍-->
        <Intro ref="intro"></Intro>
        <!--活动规则-->
        <Rule ref="rule"></Rule>
        <!--编辑-->
        <Edit ref="edit" @closeDialog="closeDialogFunc"></Edit>
    </div>
</template>

<script>
    import Intro from "../part/Intro.vue";
    import Rule from "../part/Rule.vue";
    import PlatformActivityApi from "@/api/platformactivity.js";
    import Edit from "./edit.vue";
    export default {
        components: {
            Edit,
            Intro,
            Rule,
        },
        data() {
            return {
                /*分类*/
                categoryData: [],
                /*表单数据*/
                tableData: [],
                /*是否打开添加弹窗*/
                open_add: false,
                /*是否打开编辑弹窗*/
                open_edit: false,
                /*当前编辑的对象*/
                userModel: {},
                commentData: [],
                loading: true,
                pageSize: 20,
                totalDataNumber: 0,
                curPage: 1,
            };
        },
        created() {
            /*获取平台活动列表*/
            this.getData();
        },
        methods: {
            /*获取平台活动列表*/
            getData() {
                let self = this;
                let Params = {};
                Params.page = self.curPage;
                Params.list_rows = self.pageSize;

                self.loading = true
                PlatformActivityApi.activity.list(Params, true)
                    .then((data) => {
                        self.loading = false;
                        self.tableData = data.data.list.data;
                        self.totalDataNumber = data.data.list.total;
                    })
                    .catch((error) => {
                        self.loading = false;
                    });
            },

            /*添加平台活动*/
            add() {
                this.$router.push({
                    path: "/platformactivity/activity/edit"
                });
            },

            /*编辑平台活动*/
            editItem(row) {
                this.$router.push({
                    path: "/platformactivity/activity/edit",
                    query: {
                        question_id: row.question_id
                    }
                });
            },
            /*删除*/
            deleteClick (row) {
                let self = this
                self.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText : '取消',
                    type             : 'warning'
                }).then(() => {
                    PlatformActivityApi.activity.delete({ activity_id: row.activity_id }, true)
                        .then((res) => {
                            if (res.code == 1) {
                                self.$message.success(res.msg)
                                self.getData()
                            } else {
                                self.$message.error('错了哦，这是一条错误消息')
                            }
                        }).catch((error) => {})
                })
            },


            goodsItem(row) {
                this.$router.push({
                    path: "/platformactivity/goods/index",
                    query: {
                        activity_id: row.activity_id
                    }
                });
            },
            honorItem(row) {
                this.$router.push({
                    path: "/platformactivity/honor/index",
                    query: {
                        activity_id: row.activity_id
                    }
                });
            },
            questionItem(row) {
                this.$router.push({
                    path: "/platformactivity/question/index",
                    query: {
                        activity_id: row.activity_id
                    }
                });
            },
            introItem(row) {
                this.$router.push({
                    path: "/platformactivity/question/index",
                    query: {
                        activity_id: row.activity_id
                    }
                });
            },

            /*选择第几页*/
            handleCurrentChange(val) {
                this.curPage = val;
                this.loading = true;
                this.getData();
            },

            /*每页多少条*/
            handleSizeChange(val) {
                this.curPage = 1;
                this.getData();
            },

            /*删除平台活动*/
            deleteItem(row) {
                let self = this;
                self.$confirm("此操作将永久删除该记录, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                })
                    .then(() => {
                        self.loading = true;
                        PlatformActivityApi.delete(
                            {
                                question_id: row.question_id
                            },
                            true
                        )
                            .then((data) => {
                                self.$message({
                                    message: data.msg,
                                    type: "success"
                                });
                                self.loading = false;
                                self.getData();
                            })
                            .catch((error) => {});
                    })
                    .catch(() => {});
            },

            handleClick(tab, event) {},

            /*关闭弹窗*/
            closeDialogFunc(e, f) {
                this.getData();
            },

        }
    };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/platformactivity/activity/index.vue